import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0fad4c9c&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad4c9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fad4c9c')) {
      api.createRecord('0fad4c9c', component.options)
    } else {
      api.reload('0fad4c9c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0fad4c9c&scoped=true&", function () {
      api.rerender('0fad4c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/fission/list.vue"
export default component.exports